import { useEffect, useState } from "react";
import { Button } from "../../components/ui/Button";

const COOLDOWN_S = 30;

/** "send a new code", disabled for a short cooldown after each send so nobody hammers the mailer. */
export function ResendButton({ onResend }: { onResend: () => Promise<unknown> }) {
  const [wait, setWait] = useState(COOLDOWN_S);
  const [pending, setPending] = useState(false);
  useEffect(() => {
    if (wait <= 0) return;
    const t = setTimeout(() => setWait((w) => w - 1), 1000);
    return () => clearTimeout(t);
  }, [wait]);

  return (
    <Button size="sm" variant="ghost" disabled={wait > 0} pending={pending} pendingLabel="sending…"
      onClick={async () => { setPending(true); try { await onResend(); } finally { setPending(false); setWait(COOLDOWN_S); } }}>
      {wait > 0 ? `send a new code (${wait}s)` : "send a new code"}
    </Button>
  );
}
